import {ActionTree, MutationTree,GetterTree} from 'vuex'
import {RootState} from '@/store/types'
import {SERVER_HOST_QR} from '@/config';
import VueI18n from '../../helpers/i18n';
import store from '@/store'

import axios from 'axios';
import {filterQuery} from "@/helpers/filter";

export interface State {
  shards: any[],
  shard: any,
  loading: boolean,
  loadShardStatus: boolean,
  count: number,
  countShards: any[],
  contactsStore: any,
  FilterShards: any,
  defFilterShards: any[],
  CurrentFilterShards: any[],
  countFiltersShards: number,
  defaultOptionTable: any,
  disableSearch: boolean
}

const defaultState: State = {
  disableSearch: false,
  defaultOptionTable: {page: 1, itemsPerPage: 20, sortBy: ['updatedAtTimestamp'], sortDesc: [false]},
  shards: [],
  shard: {},
  loading: false,
  loadShardStatus: true,
  count: 0,
  countShards: [],
  contactsStore: null,
  CurrentFilterShards: [],
  defFilterShards: [
    {type: 'typeFilterFio', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'categoryFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'hotLevelFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'surveyFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'notesFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'typeContact', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'datePickerFilter', value: []},
    {type: 'isArchiveFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'search', value: ''},
    {type: 'options', value: {page: 1, itemsPerPage: 20, sortBy: ['updatedAtTimestamp'], sortDesc: [false]}},
  ],
  FilterShards: [
    {type: 'typeFilterFio', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'categoryFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'hotLevelFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'surveyFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'notesFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'typeContact', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'datePickerFilter', value: []},
    {type: 'isArchiveFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
    {type: 'search', value: ''},
    {type: 'options', value: {page: 1, itemsPerPage: 20, sortBy: ['updatedAtTimestamp'], sortDesc: [false]}},
  ],
  countFiltersShards: 0
};

const getters:GetterTree<State, RootState> = {
  disableSearch: (state: State) => state.disableSearch,
  getDefaultOptionTable: (state: State) => state.defaultOptionTable,
  getCurrentFilterShards: (state: State) => state.CurrentFilterShards,
  loading: (state: State) => state.loading,
  loadShardStatus: (state: State) => state.loadShardStatus,
  shards: (state: State) => state.shards,
  shard: (state: State) => state.shard,
  count: (state: State) => state.count,
  countShards: (state: State) => state.countShards,
  contactsStore: (state: State) => state.contactsStore,
  GetFilterShards: (state: State, root:RootState) => {
    VueI18n.locale = store.state.locale.locale
    // console.log(store.state.locale.locale);
    return state.FilterShards
  },
  GetCountFiltersShards(state: State) {
    let count: number = 0
    if (state.FilterShards[0].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    if (state.FilterShards[1].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    if (state.FilterShards[2].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    if (state.FilterShards[3].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    if (state.FilterShards[4].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    if (state.FilterShards[5].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    if (state.FilterShards[6].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }

    if (state.FilterShards[7].value.filter((el: any) => {
      return el.id != 'all'
    }).length > 0) {
      count++
    }
    return count
  },
}

const mutations: MutationTree<State> = {
  clearStore(state:State){
    state.shards = []
    state.FilterShards = state.defFilterShards
    state.CurrentFilterShards = []
    const search = state.FilterShards[8]
    const options = state.FilterShards[9]
    state.FilterShards = [
      {type: 'typeFilterFio', value: []},
      {type: 'categoryFilter', value: []},
      {type: 'hotLevelFilter', value: []},
      {type: 'surveyFilter', value: []},
      {type: 'notesFilter', value: []},
      {type: 'typeContact', value: []},
      {type: 'datePickerFilter', value: []},
      {type: 'isArchiveFilter', value: []},
      {type: 'search', value: ''},
      options
    ]
  },
  setDisableSearch(state: State, payload: boolean) {
    state.disableSearch = payload
  },
  setPageOne(state: State) {
    state.FilterShards[9].value.page = 1
  },
  setOptionsTableDefault(state: State) {
    state.FilterShards[9].value = state.defaultOptionTable
  },
  setOptionsTable(state: State, payload: object) {
    state.FilterShards[9].value = payload
  },
  clearSearch(state: State) {
    state.FilterShards[8].value = ''
    state.FilterShards[9].value.page = 1
  },
  setCurrentFilterShards(state: State) {
    state.CurrentFilterShards = JSON.parse(JSON.stringify(state.FilterShards))
  },
  setAttributes(state: State, payload: any) {
    state.shards = state.shards.map((shard: any) => {
      return (shard.id == payload.id) ? payload : shard
    })
  },
  setShards(state: State, payload: any[]) {
    state.shards = payload
  },
  setShard(state: State, payload: any[]) {
    state.shard = payload
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loading = payload
  },
  setLoadShardStatus(state: State, payload: boolean) {
    state.loadShardStatus = payload
  },
  setCount(state: State, payload: number) {
    state.count = payload
  },
  setCountShards(state: State, payload: any) {
    state.countShards = payload
  },
  setContact(state: State, payload: any) {
    state.shard.contactBlock.contacts.push(payload)
  },
  setLocation(state: State, payload: any) {
    payload.type = 'location'
    state.shard.contactBlock.locations.push(payload)
  },
  setContactsStore(state: State, payload: any[]) {
    state.contactsStore = payload
  },
  setMediaAttachment(state: State, payload: any) {
    state.shard.mediaAttachments.forEach((media: any) => {
      if (media.id == payload.id) {
        media.text = payload.params.text
      }
    })
  },
  deleteDataSource(state: State, payload: any) {
    state.shards.forEach((shard: any) => {
      if(shard.id == payload.shardId) {
        shard.dataSources = shard.dataSources.filter((elem: any) => elem.id != payload.noteId)
      }
    })
    state.shard.dataSources = state.shard.dataSources.filter((elem: any) => elem.id != payload.noteId)
  },
  deleteMediaAttachment(state: State, payload: any) {
    state.shard.mediaAttachments = state.shard.mediaAttachments.filter((elem: any) => elem.id != payload)
  },
  setFilterShards(state: State, payload: any) {
    state.FilterShards.filter((ele: any) => {
      return ele.type == payload.type
    })[0].value = [] = payload.value
  },
  clearFilterShards(state: State, payload: boolean = true) {
    const search = state.FilterShards[8]
    const options = state.FilterShards[9]
      state.FilterShards = [
        {type: 'typeFilterFio', value: []},
        {type: 'categoryFilter', value: []},
        {type: 'hotLevelFilter', value: []},
        {type: 'surveyFilter', value: []},
        {type: 'notesFilter', value: []},
        {type: 'typeContact', value: []},
        {type: 'datePickerFilter', value: []},
        {type: 'isArchiveFilter', value: []},
        search,
        options
      ]
    state.CurrentFilterShards = []
  },
}

const actions: ActionTree<State, RootState> = {
  async loadShardsFromServer({commit, state}, payload: any) {
    commit('setLoadStatus', true)

    const {sortBy, sortDesc, page, itemsPerPage} = payload
    // console.log('payload',payload)
    try {
      let sb = sortDesc[0] ? sortBy[0] : '-' + sortBy[0]
      if (sb == 'undefined' || sb == '-undefined') {
        sb = '-updatedAtTimestamp'
      }
      const {data} = await axios.get(SERVER_HOST_QR + 'shards?sort=' + sb +
        '&page=' + page +
        '&per-page=' + itemsPerPage +
        '&expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb')
      if (data.error) {
        throw (data.error)
      }
      commit('setShards', data.data.models)
      commit('setCount', data.data.allCount)
      commit('setLoadStatus', false)

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'contact-block/field/type')
      commit('setContactsStore', data.data)
    } catch (e) {

    }
  },
  async loadContactsFromServer({commit, state}) {
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'contact-block/field/type')
      commit('setContactsStore', data.data)
    } catch (e) {

    }
  },
  async loadShardsFromServerWithQuery({commit, state}) {
    commit('setLoadStatus', true)
    commit('setDisableSearch', true)
    const payload = filterQuery(state.FilterShards);

    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'shards?' + payload +
        'expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb')
      if (data.error) {
        throw (data.error)
      }
      commit('setShards', data.data.models)
      commit('setCount', data.data.allCount)
      commit('setLoadStatus', false)
      commit('setDisableSearch', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
    try {
      if (!state.contactsStore) {
        const {data} = await axios.get(SERVER_HOST_QR + 'contact-block/field/type')
        commit('setContactsStore', data.data)
      }
    } catch (e) {

    }
  },
  async loadShardFromServer({commit, state}, payload: string) {
    commit('setLoadShardStatus', true)
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'shards/' + payload + '?expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb')
      if (data.error) {
        throw (data.error)
      }
      data.data.contactBlock.contacts.forEach((contact: any) => {
        contact.edit = false
        contact.editType = false
      })
      data.data.contactBlock.locations.forEach((location: any) => {
        location.edit = false
        location.editType = false
        location.type = 'location'
      })
      data.data.dataSources.forEach((source: any) => {
        source.select = false
      })
      data.data.mediaAttachments.forEach((media: any) => {
        if (media.type == 'voice') {
          media.play = false;
          media.mute = false;
        }
      })
      commit('setShard', data.data)
      commit('setLoadShardStatus', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadShardStatus', false)
    }
  },
  async saveShardFromServer({commit, state}, payload: any) {
    const id = payload.id
    let params = payload.params
    // console.log('payload', payload)
    try {
      const {data} = await axios.patch(SERVER_HOST_QR + 'shards/' + id + '?expand=dataSources,isArchived,contactBlock,mediaAttachmentsCount,authorName,surveyCount,mediaAttachments,imageLink,surveyDataWeb', params)
      data.data.contactBlock.contacts.forEach((contact: any) => {
        contact.edit = false
        contact.editType = false
      })
      data.data.contactBlock.locations.forEach((location: any) => {
        location.edit = false
        location.editType = false
        location.type = 'location'
      })
      data.data.dataSources.forEach((source: any) => {
        source.select = false
      })
      data.data.mediaAttachments.forEach((media: any) => {
        if (media.type == 'voice') {
          media.play = false;
        }
      })
      commit('setAttributes', data.data)
      commit('setShard', data.data)
    } catch (e) {
    }
  },
  async editContactFromServer({commit, state}, payload: any) {
    const id = payload.id
    let params = payload.params
    try {
      const {data} = await axios.patch(SERVER_HOST_QR + 'shards/contacts/' + id, params)
      // console.log(data)
    } catch (e) {
    }
  },
  async editLocationFromServer({commit, state}, payload: any) {
    const id = payload.id
    let params = payload.params
    try {
      const {data} = await axios.patch(SERVER_HOST_QR + 'shards/locations/' + id, params)
      // console.log(data)
    } catch (e) {
    }
  },
  async addContactFromServer({commit, state}, payload: any) {
    const id = payload.shard_id
    let params = payload.params

    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'shards/' + id + '/contacts', params)
      data.data.edit = false
      data.data.editType = false
      commit('setContact', data.data)
    } catch (e) {
    }
  },
  async addLocationFromServer({commit, state}, payload: any) {
    const id = payload.shard_id
    let params = payload.params

    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'shards/' + id + '/locations', params)
      data.data.edit = false
      data.data.editType = false
      commit('setLocation', data.data)
    } catch (e) {
    }
  },
  async deleteDataSourceFromServer({commit, state}, payload: any) {
    try {
      const {data} = await axios.delete(SERVER_HOST_QR + 'shard/data-sources/' + payload.noteId)
      commit('deleteDataSource', payload)
      // console.log(data)
    } catch (e) {
    }
  },
  async saveMediaAttachmentFromServer({commit, state}, payload: any) {
    const id = payload.id
    let params = payload.params
    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'shard/media-attachments/' + id, params)
      commit('setMediaAttachment', payload)
    } catch (e) {
    }
  },
  async deleteMediaAttachmentFromServer({commit, state}, payload: any) {
    const id = payload
    try {
      const {data} = await axios.delete(SERVER_HOST_QR + 'shard/media-attachments/' + id)
      commit('deleteMediaAttachment', payload)
    } catch (e) {
    }
  },
  async loadCountShards({commit, state}) {
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'shards/export/count')
      if (data.error) {
        throw (data.error)
      }
      commit('setCountShards', data.data)

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
    }
  },
  async loadExportAllShards({commit, state}, payload: any) {
    try {
      let params = payload.params
      let options = {
        headers: {
          'LF-Localization': payload.locale
        }
      }
      const {data} = await axios.post(SERVER_HOST_QR + 'shards/export?format=' + payload.format, params, options)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [payload.message]
      })

      if (data.error) {
        throw (data.error)
      }
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      return false
    }
  },
  async loadExportOneShard({commit, state}, payload: any) {
    try {
      let params = payload.params
      let options = {
        headers: {
          'LF-Localization': payload.locale
        }
      }
      const {data} = await axios.post(SERVER_HOST_QR + 'shards/' + payload.id + '/export', params, options)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [payload.message]
      })

      if (data.error) {
        throw (data.error)
      }
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      return false
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
